export type SelectedBusinessDocument = {
  businessDocumentId: string;
  searchableNumber: number;
  documentTitle: string;
  mfFileId: string;
};

export const MaxSelectedCount = 5;
